/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbExportGapFormateursGridDto } from './FcbExportGapFormateursGridDto';
import {
    FcbExportGapFormateursGridDtoFromJSON,
    FcbExportGapFormateursGridDtoFromJSONTyped,
    FcbExportGapFormateursGridDtoToJSON,
} from './FcbExportGapFormateursGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbExportGapFormateursGridDtoPaginatedResults
 */
export interface FcbExportGapFormateursGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbExportGapFormateursGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbExportGapFormateursGridDto>}
     * @memberof FcbExportGapFormateursGridDtoPaginatedResults
     */
    results?: Array<FcbExportGapFormateursGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbExportGapFormateursGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbExportGapFormateursGridDtoPaginatedResults interface.
 */
export function instanceOfFcbExportGapFormateursGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbExportGapFormateursGridDtoPaginatedResultsFromJSON(json: any): FcbExportGapFormateursGridDtoPaginatedResults {
    return FcbExportGapFormateursGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbExportGapFormateursGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbExportGapFormateursGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbExportGapFormateursGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbExportGapFormateursGridDtoPaginatedResultsToJSON(value?: FcbExportGapFormateursGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbExportGapFormateursGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

